export default __webpack_public_path__ + "static/BannerGenericImageTextActionWithCharTitleAndCustomCard-04ecbda903d2d6fa167fdf1814fba772.jpg";